import { Outlet, useLocation } from 'react-router-dom'
import Navbar from './Navbar'
import FloatingRoomControls from '../Room/FloatingRoomControls'
import { useRoomDetection } from '@/hooks/useRoomDetection'
import { cn } from '@/lib/utils'

const ProfessorView: React.FC = () => {
  const location = useLocation()
  const { hasRoomId, roomId } = useRoomDetection()

  const isProfessorPlayerView = location.pathname.match(
    /prof-dashboard\/[A-Z0-9]{10}\/player/
  )
  const isAdjudicate = location.pathname.match(
    /rooms\/[A-Z0-9]{10}\/adjudicate/
  )
  const isCharterMonitor = location.pathname.match(
    /rooms\/[A-Z0-9]+\/charter-monitoring\/(prep|group)\//
  )
  const found = isProfessorPlayerView || isAdjudicate || isCharterMonitor

  return (
    <div className='h-screen flex flex-col '>
      {!found && <Navbar />}
      <div
        className={cn(
          'flex-grow',
          isAdjudicate
            ? 'overflow-y-auto overflow-x-hidden'
            : found
              ? 'overflow-hidden'
              : 'overflow-auto'
        )}
      >
        <Outlet />
      </div>
      {hasRoomId && <FloatingRoomControls roomId={roomId} />}
    </div>
  )
}

export default ProfessorView
